import { render, staticRenderFns } from "./BadgeUpload.vue?vue&type=template&id=1cc2af15&scoped=true&"
import script from "./BadgeUpload.vue?vue&type=script&lang=js&"
export * from "./BadgeUpload.vue?vue&type=script&lang=js&"
import style0 from "./BadgeUpload.vue?vue&type=style&index=0&id=1cc2af15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc2af15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VBtn,VFileInput})
